import * as React from 'react';
import { Skeleton } from '@/components/ui/skeleton';
import { cn } from '@/lib/utils';


export function KpiSkeleton() {
  return (
    <div className="flex items-start justify-between gap-3">
      <div className="space-y-2">
        <Skeleton className="h-[11px] w-[60px]" />
        <Skeleton className="h-[20px] w-[96px]" />
        <Skeleton className="h-[12px] w-[120px]" />
      </div>
      <Skeleton className="h-[22px] w-[72px]" />
    </div>
  );
}

export function WidgetHeaderSkeleton({ withSubtitle = false }: { withSubtitle?: boolean }) {
  return (
    <div className="space-y-1.5">
      <Skeleton className="h-[14px] w-[140px]" />
      {withSubtitle && <Skeleton className="h-[12px] w-[90px]" />}
    </div>
  );
}

export function ListSkeleton({ rows = 4, className }: { rows?: number; className?: string }) {
  return (
    <div className={cn('space-y-3', className)}>
      {Array.from({ length: rows }).map((_, i) => (
        <div key={i} className="flex items-center justify-between gap-3">
          <div className="flex min-w-0 items-center gap-2">
            <Skeleton className="h-2 w-2 shrink-0 rounded-full" />
            <Skeleton className="h-[11px] w-[80px]" />
          </div>
          <Skeleton className="h-[11px] w-[40px] shrink-0" />
        </div>
      ))}
    </div>
  );
}

export function EntityListSkeleton({ rows = 5 }: { rows?: number }) {
  return (
    <div className="space-y-1">
      {Array.from({ length: rows }).map((_, i) => (
        <div key={i} className="flex items-center gap-3 py-2.5">
          <Skeleton className="h-8 w-8 shrink-0 rounded-full" />
          <div className="min-w-0 flex-1 space-y-1.5">
            <Skeleton className="h-[13px] w-[120px]" />
            <Skeleton className="h-[11px] w-[80px]" />
          </div>
          <Skeleton className="h-[13px] w-[60px] shrink-0" />
        </div>
      ))}
    </div>
  );
}

export function DonutSkeleton({ diameter = 160 }: { diameter?: number }) {
  return (
    <div className="flex justify-center">
      <Skeleton className="rounded-full" style={{ width: diameter, height: diameter }} />
    </div>
  );
}

export function SegmentedBarSkeleton({ legend = 3 }: { legend?: number }) {
  return (
    <div className="space-y-3">
      <Skeleton className="h-2 w-full rounded-full" />
      <div className="flex flex-wrap gap-3">
        {Array.from({ length: legend }).map((_, i) => (
          <Skeleton key={i} className="h-[11px] w-[70px]" />
        ))}
      </div>
    </div>
  );
}

export function ChartSkeleton({ height = 240 }: { height?: number }) {
  return <Skeleton className="w-full rounded-xl" style={{ height }} />;
}
